import React, { useState, useRef } from 'react';
import { Button, TextField, Checkbox, FormControlLabel, FormGroup, Box, Grid,Card } from '@mui/material';
import { Link } from 'react-router-dom';
import SaveIcon from '@mui/icons-material/Save';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import { toast } from 'react-toastify';
import axios from 'axios';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Typography from '@mui/material/Typography';
import ViewUserTab from './ViewUsertab';
import user_img from '../../../assets/images/user_img.png'

const EditUserForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    image: null,
    publish: false,  // Checkbox state added here
  });

  const fileInputRef = useRef(null);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({
      ...formData,
      [name]: type === 'checkbox' ? checked : value, // Update the checkbox correctly
    });
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setFormData({
      ...formData,
      image: file,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formDataToSend = new FormData();
  
    // Prepare the data to be sent
    Object.keys(formData).forEach((key) => {
      if (formData[key]) {
        formDataToSend.append(`itemDetails[${key}]`, formData[key]);
      }
    });
  
    // Add image if present
    if (formData.image) {
      formDataToSend.append('mediaFiles[]', formData.image);
    }
  
    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/items/create`, formDataToSend, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
  
      if (response.status === 201) {
        toast.success(response.data.message);
        setFormData({
          name: '',
          email: '',
          phone: '',
          image: null,
          publish: false,  // Reset checkbox state
        });
  
        // Log the formData after submission
        console.log('Form submitted successfully:', formData);
      }
    } catch (error) {
      toast.error('User not updated');
      console.error('Error creating item:', error);
  
      // Log the error and formData in case of failure
      console.log('Form submission failed:', formData);
    }
  };
  return (
    <>
    <ViewUserTab />
    <Box sx={{ maxWidth: '70%', margin: 'auto', padding: 2 }}>
      <form onSubmit={handleSubmit}>
        <fieldset style={{ border: '1px solid #ccc', padding: '20px', borderRadius: '8px', marginBottom: '20px' }}>
          <legend style={{ padding: '8px', width: 'auto', background: '#3C7F10', color: '#fff', borderRadius: '8px' }}>
            Edit User
          </legend>

          <Grid className='input-field-cls' container spacing={{ xs: 2, md: 3 }} columns={{ xs: 4, sm: 8, md: 12 }}>
            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                First Name
              </Typography>
              <Typography variant="p" sx={{ marginBottom: 1, fontWeight: '300',color:'#67757c' }}>
              Mohamed Hassan
              </Typography>
            </Grid>

            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                Phone
              </Typography>
              <Typography variant="p" sx={{ marginBottom: 1, fontWeight: '300',color:'#67757c' }}>
              
9*******
              </Typography>
            </Grid>

            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
                Email
              </Typography>
              <Typography variant="p" sx={{ marginBottom: 1, fontWeight: '300',color:'#67757c' }}>
              M**********@gmail.com
              </Typography>
            </Grid>

            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
              Profile Image
              </Typography>
              <Box className='user-details-img-cls' sx={{width:'100px',height:'100px'}}>
                <img src={user_img} alt="" srcset="" />
              </Box>
            </Grid>
            <Grid item xs={2} sm={6}>
              <Typography variant="subtitle1" sx={{ marginBottom: 1, fontWeight: '500' }}>
              Address
              </Typography>
              <Box sx={{border:'1px solid rgba(120, 130, 140, 0.13)',padding:'10px'}}>
              <Typography variant="p" sx={{ marginBottom: 1, fontWeight: '300',color:'#67757c' }}>
                 null,23CV+32H, Salalah, Oman null  
              </Typography> 
              <Box sx={{gap:1,display:'flex',mt:1}}>
              <Button variant="contained" sx={{bgcolor:'#33ab5b',boxShadow:'unset',padding:"5px",textTransform:'lowercase'}}>null</Button>
              <Button variant="contained" sx={{bgcolor:'#33ab5b',boxShadow:'unset',padding:"5px",textTransform:'lowercase'}}>Default</Button>
              </Box>
              </Box>
            </Grid>
          </Grid>
        </fieldset>
        <Box sx={{ display: 'flex', justifyContent: 'center', gap: 2 }}>
          <Link to="/users-customer" style={{ textDecoration: 'none' }}>
            <Button variant="contained" sx={{ bgcolor: '#979797', color: '#fff', boxShadow: 'unset' }}>
              <SettingsBackupRestoreIcon sx={{ pr: 1 }} />
              Back
            </Button>
          </Link>
        </Box>
      </form>
    </Box>
  </>
  );
};

export default EditUserForm;
